import { format, isValid, parseISO } from 'date-fns';
import { TextProps, Typography } from './Typography';

type GetFormattedDateStringProps = {
  date: string;
  formatOverride?: string;
  nullOverride?: string;
  prefix?: string;
  suffix?: string;
};

export const getFormattedDateString = ({
  date,
  formatOverride = 'Pp',
  nullOverride = '-',
  prefix = '',
  suffix = '',
}: GetFormattedDateStringProps) => {
  const parsedDate = parseISO(date || '');
  const validDate = isValid(parsedDate);
  return validDate
    ? `${prefix}${format(parsedDate, formatOverride || 'Pp')}${suffix}`
    : nullOverride;
};

type DateDisplayProps = TextProps & GetFormattedDateStringProps;

export const DateDisplay = ({
  date,
  formatOverride,
  nullOverride,
  prefix,
  suffix,
  ...textProps
}: DateDisplayProps) => {
  const formattedDate = getFormattedDateString({
    date,
    nullOverride,
    formatOverride,
    prefix,
    suffix,
  });
  return (
    <Typography noWrap handleOverFlow variant="body2" {...textProps}>
      {formattedDate}
    </Typography>
  );
};
